const ABSOLUTE_URL_PATTERN = /^https?:\/\//i;

// Bare-domain website values from the API (e.g. `example.com`) aren't valid
// `href` targets on their own — prefix with `https://` so links resolve
// instead of being treated as a relative path. Protocol-relative values
// (`//host`) are deliberately coerced to `https://host` rather than kept
// scheme-relative.
export function normalizeExternalUrl(url: string | null | undefined): string {
  const trimmed = url?.trim().replace(/^\/\//, '');

  if (!trimmed) {
    return '';
  }

  return ABSOLUTE_URL_PATTERN.test(trimmed) ? trimmed : `https://${trimmed}`;
}
